import { Breadcrumbs } from './Breadcrumbs';
export const ChordSheet = ({ chord: { name, columns }}) => (
  <div class='component__chord-sheet'>
    <Breadcrumbs current={name}/>
    <div class='component__chord-sheet__columns'>
      {columns.map(column => <pre>{column}</pre>)}
    </div>
  </div>
);
